import { CalendarContextMenu } from "@/features/calendar/components/CalendarContextMenu";
import { UNASSIGNED_OPEN_SLOT_CALENDAR_EVENT } from "@/features/calendar/constants";
import { useDroppable } from "@dnd-kit/core";
import { useState } from "react";

import { HourBlock, NotWorkingHourBlock } from "./components";

interface DropProps {
  id: string;
  date: Date;
  emailId?: string;
  selectedTeam?: number;

  color?: string;
  isNotWorking?: boolean;
  width: number;
  first?: boolean;
  last?: boolean;
  noLeftBorder?: boolean;
  onClick?: () => void;
}
export const DroppableHourBlock = ({
  id,
  emailId,
  selectedTeam,
  date,
  width,
  first,
  last,
  color,
  isNotWorking,
  noLeftBorder,
  onClick,
}: DropProps) => {
  const [menuRef, setMenuRef] = useState<HTMLDivElement | null>(null);

  const { setNodeRef, active } = useDroppable({
    id,
    data: {
      emailId,
      assignedTeam: selectedTeam,
    },
    // "Unassigned open slots" is a read-only lane for now: nothing may be
    // dropped into it, so we opt the hour blocks out of dnd-kit entirely.
    disabled: emailId === UNASSIGNED_OPEN_SLOT_CALENDAR_EVENT,
  });

  return (
    <CalendarContextMenu
      menuRef={menuRef}
      date={date}
      emailId={emailId}
      selectedTeam={selectedTeam}
      onClick={onClick}
    >
      {isNotWorking ? (
        <NotWorkingHourBlock
          ref={(r) => {
            setNodeRef(r);
            setMenuRef(r);
          }}
          width={width}
          first={first}
          last={last}
          noLeftBorder={noLeftBorder}
          onClick={active ? undefined : onClick}
        />
      ) : (
        <HourBlock
          ref={(r) => {
            setNodeRef(r);
            setMenuRef(r);
          }}
          width={width}
          first={first}
          last={last}
          color={color}
          noLeftBorder={noLeftBorder}
          onClick={active ? undefined : onClick}
        />
      )}
    </CalendarContextMenu>
  );
};
